import { render, staticRenderFns } from "./NotificationDesktop.vue?vue&type=template&id=48db4353&scoped=true&"
import script from "./NotificationDesktop.vue?vue&type=script&lang=js&"
export * from "./NotificationDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDesktop.vue?vue&type=style&index=0&id=48db4353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db4353",
  null
  
)

export default component.exports